import { INTERPOLATION_CHARS } from '../constants';
import { debugRun } from '../debug/debug.utils';

export const textPrefix = (
    prefix: string,
    text?: string,
    fallbackString?: string
): string | undefined => (
    text?.trim().length ? `${prefix}${text}` : fallbackString
);

export const encode = (obj: {}): string => {
    return window.encodeURIComponent(window.btoa(JSON.stringify(obj)));
};

export const decode = (str: string): any => {
    return JSON.parse(window.atob(window.decodeURIComponent(str)));
};

export const joinStrings = (
    symbol: string = ', ',
    ...strings: (string | null | undefined)[]
): string => strings
    .filter(str => str && str.trim().length > 0)
    .join(symbol);

export const interpolateString = (
    str: string,
    replaceVariables: Record<string, string>
) => {
    return str
        .replace(
            new RegExp(INTERPOLATION_CHARS[0] + '([^' + INTERPOLATION_CHARS[1] + ']+)' + INTERPOLATION_CHARS[1], 'g'),
            (match, key) => {
                const value = replaceVariables[key];

                debugRun(({ error }) => {
                    if (!value) {
                        error(`String interpolation failure: Missing value for key: "${key}".\n     Raw string: ${str}`);
                    }
                });

                return value;
            }
        );
};
